


















import { Component, Vue, Watch } from "vue-property-decorator";
import { LoadingStatusType } from "../../enums/enums";
import { namespace } from "vuex-class";
import Liff from "@line/liff";
import { NewObject } from "@/helper/shareHelper";
import CompanyList from "@/components/company/CompanyList.vue";
import { MerchantModel } from "@/model/merchant";
import { UserModel } from "@/model/user";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";

const StoreLineConnect = namespace("LineConnect");
const StoreLineToken = namespace("LineToken");
const StoreUserInfo = namespace("UserInfo");
const StoreLoading = namespace("Loading");

@Component({
  components: { CompanyList },
})
export default class SelectCompany extends Vue {
  @StoreUserInfo.Getter
  private getUserModel!: UserModel;

  @StoreLineToken.Getter
  private getLineAccessToken!: string;

  @StoreLineConnect.Getter
  private getLineConnectLoadingStatus!: LoadingStatusType;
  @StoreLineConnect.Action
  private LineConnect!: (_input: any) => void;

  @StoreLoading.Action
  private IsLoading!: (loadingStatus: boolean) => void;

  private select = { merchantId: 0 };
  private setCompanyLoading = false;

  @Watch("getUserModel", { immediate: true })
  getUserModelChanged(newVal: UserModel) {
    if (!newVal.userId) {
      this.$router.push({ name: "login" });
    } else {
      this.IsLoading(false);
    }
  }
  @Watch("getLineConnectLoadingStatus", {})
  getLineConnectLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      Liff.sendMessages([
        {
          type: "text",
          text: "#Welcome",
        },
      ])
        .then(() => {
          Liff.closeWindow();
          this.setCompanyLoading = false;
        })
        .catch((err) => {
          Liff.closeWindow();
          this.setCompanyLoading = true;
        });
    } else if (newVal == LoadingStatusType.Loading) {
      this.setCompanyLoading = true;
    } else if (newVal == LoadingStatusType.Fail) {
      Liff.closeWindow();
    }
  }

  public SetCompany() {
    const input = {
      merchantId: this.select.merchantId,
      accessToken: this.getLineAccessToken,
    };
    this.LineConnect(input);
  }
}
